// extracted by mini-css-extract-plugin
module.exports = {"noBookings":"NoBookings_noBookings__3qrR8","message":"NoBookings_message__1v4ok"};